import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";
import { SEO } from "../components/seo/SEO";

export default function Impressum() {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={`${t("impressum.title")} | Equna`}
        description={t("legal.seo.imprintDescription")}
        canonical="/impressum"
      />
      <LegalPageLayout title={t("impressum.title")}>
      <div className="space-y-8">
        <section>
          <h2 className="text-xl font-semibold text-slate-900 mb-4">
            {t("impressum.providerInfo")}
          </h2>
          <address className="not-italic text-slate-600 leading-relaxed">
            <strong>{t("impressum.address.name")}</strong><br />
            {t("impressum.address.street")}<br />
            {t("impressum.address.city")}<br />
            {t("impressum.address.country")}
          </address>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-900 mb-4">
            {t("impressum.contact.title")}
          </h2>
          <p className="text-slate-600">
            {t("impressum.contact.email")}:{" "}
            <a
              href="mailto:contact@equna.eu"
              className="text-emerald-600 hover:text-emerald-700 transition-colors font-medium"
            >
              contact@equna.eu
            </a>
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-900 mb-4">
            {t("impressum.onlineDispute.title")}
          </h2>
          <p className="text-slate-600 leading-relaxed">
            {t("impressum.onlineDispute.text")}{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-600 hover:text-emerald-700 transition-colors font-medium"
            >
              {t("impressum.onlineDispute.linkLabel")}
            </a>{" "}
            {t("impressum.onlineDispute.suffix")}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-900 mb-4">
            {t("impressum.liability.title")}
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-base font-semibold text-slate-900 mb-2">
                {t("impressum.liability.content.title")}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                {t("impressum.liability.content.p1")}
              </p>
              <p className="text-sm text-slate-600 leading-relaxed mt-2">
                {t("impressum.liability.content.p2")}
              </p>
            </div>

            <div>
              <h3 className="text-base font-semibold text-slate-900 mb-2">
                {t("impressum.liability.links.title")}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                {t("impressum.liability.links.p1")}
              </p>
              <p className="text-sm text-slate-600 leading-relaxed mt-2">
                {t("impressum.liability.links.p2")}
              </p>
            </div>

            <div>
              <h3 className="text-base font-semibold text-slate-900 mb-2">
                {t("impressum.liability.copyright.title")}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                {t("impressum.liability.copyright.p1")}
              </p>
              <p className="text-sm text-slate-600 leading-relaxed mt-2">
                {t("impressum.liability.copyright.p2")}
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-900 mb-4">
            {t("impressum.dispute.title")}
          </h2>
          <p className="text-slate-600 leading-relaxed border-l-4 border-slate-200 pl-4">
            {t("impressum.dispute.text")}
          </p>
        </section>
      </div>
      </LegalPageLayout>
    </>
  );
}

